<template>
  <div class="video-mux-wrapper">
    <video
      ref="muxVideoPlayer"
      class="mux-video-js"
      :controls="controls"
      :id="`${playerId}`"
    ></video>
    <span v-if="loading" aria-hidden="true" class="align-middle spinner-border"></span>
  </div>
</template>
<script>
import muxjs from 'mux.js'

export default {
  name: 'MuxVideoPlayer',
  props: {
    src: {
      type: String,
    },
    playerId: {
      type: String,
      default: '',
    },
    controls: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      player: null,
      mimeCodec: 'video/mp4; codecs="mp4a.40.2,avc1.64001f"',
      mediaSource: null,
      video: null,
      loading: false,
    }
  },
  mounted() {
    if (this.src != '' && this.src != null) {
      this.initialize()
    }
  },
  methods: {
    initialize() {
      this.loading = true
      this.player = this.$refs.muxVideoPlayer
      const self = this
      if (window.MediaSource && MediaSource.isTypeSupported(this.mimeCodec)) {
        const mediaSource = new MediaSource()
        this.mediaSource = mediaSource
        setTimeout(() => {
          const video = document.getElementById(`${this.playerId}`)
          video.src = URL.createObjectURL(mediaSource)
          this.video = video
          mediaSource.addEventListener('sourceopen', this.appendSource)

          mediaSource.addEventListener('error', function (e) {
            self.$emit('error')
          })

          video.addEventListener('ended', function () {
            self.$emit('ended')
          })
        }, 1000)
      }
    },

    appendSource() {
      const transmuxer = new muxjs.mp4.Transmuxer()
      URL.revokeObjectURL(this.video.src)
      const sourceBuffer = this.mediaSource.addSourceBuffer(this.mimeCodec)
      const self = this
      transmuxer.on('data', (video) => {
        this.loading = false
        let data = new Uint8Array(video.initSegment.byteLength + video.data.byteLength)
        data.set(video.initSegment, 0)
        data.set(video.data, video.initSegment.byteLength)
        sourceBuffer.appendBuffer(data)
        sourceBuffer.addEventListener('updateend', function () {
          self.mediaSource.endOfStream()
        })
        // reset the 'data' event listener to just append (moof/mdat) boxes to the Source Buffer
        transmuxer.off('data')
        self.$emit('ready')
      })
      fetch(this.src)
        .then((response) => {
          if (!response.ok) throw new Error(`Unable to load media: ${response.status}`)
          return response.arrayBuffer()
        })
        .then((response) => {
          transmuxer.push(new Uint8Array(response))
          transmuxer.flush()
        })
        .catch(() => {
          this.loading = false
          this.$emit('error')
        })
    },
  },
}
</script>
